import { useNavigate } from "react-router-dom";
import { Button, Row, Col } from "antd";
import { Calendar, Globe, Users } from "lucide-react";
import { format } from "date-fns";
import { getCommunityStatCards } from "../../commons/community.helpers";

function OverviewTab({
  community,
  stats,
  statsFailed,
  onRetryStats,
  setActiveTab,
}) {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 animate-in">
      <div className="space-y-6 lg:col-span-2">
        <div className="rounded-2xl border border-border/50 bg-card p-6 shadow-sm space-y-4">
          <h3 className="font-bold text-sm uppercase tracking-wider text-muted-foreground">
            About
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed whitespace-pre-wrap">
            {community.description}
          </p>
        </div>

        <Row gutter={[16, 16]}>
          {getCommunityStatCards(stats).map(({ label, value }) => (
            <Col key={label} xs={24} sm={12} lg={6}>
              <div className="rounded-2xl border border-border/50 bg-card p-4 space-y-1">
                <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                  {label}
                </p>
                <p className="text-2xl font-bold tracking-tight">
                  {value ?? "—"}
                </p>
              </div>
            </Col>
          ))}
        </Row>
        {statsFailed && (
          <p className="text-sm text-muted-foreground">
            Couldn&apos;t load community stats.{" "}
            <Button type="link" size="small" onClick={onRetryStats}>
              Retry
            </Button>
          </p>
        )}
      </div>

      <div className="space-y-4">
        <div className="rounded-2xl border border-border/50 bg-card p-5 space-y-3">
          <h4 className="font-semibold text-sm flex items-center">
            <Calendar className="h-4 w-4 mr-2 text-primary" />
            Quick Links
          </h4>
          <div className="space-y-2 text-sm">
            <Button
              type="default"
              className="w-full justify-start"
              icon={<Globe className="h-4 w-4" />}
              onClick={() =>
                navigate(`/shoup-community/events?community_id=${community.community_id}`)
              }
            >
              Manage Events
            </Button>
            <Button
              type="default"
              className="w-full justify-start"
              icon={<Globe className="h-4 w-4" />}
              onClick={() => navigate("/shoup-community/memberships")}
            >
              Memberships
            </Button>
            <Button
              type="default"
              className="w-full justify-start"
              icon={<Users className="h-4 w-4" />}
              onClick={() => setActiveTab("members")}
            >
              View All Members
            </Button>
          </div>
        </div>

        <div className="rounded-2xl border border-border/50 bg-card p-5 space-y-3">
          <h4 className="font-semibold text-sm">Created</h4>
          <p className="text-sm text-muted-foreground">
            {community.audit?.created_at && format(new Date(community.audit.created_at), "MMMM d, yyyy")}
          </p>
        </div>
      </div>
    </div>
  );
}

export default OverviewTab;
